// const env = 'stage';//开发
// const env = 'prod';//线上
let url = window.location.href
var parts = url.split('.com'); 
var domain = parts[0].split('.')[1]; // 提取"//"后的部分  
const envConfigs = {
  
  prodQqs: {
    baceUrl: `https://mini.${domain}.com/center-api-adminqqs/`,
    picUrl: `https://a-cdn.${domain}.com/`,
    uploadUrl: `https://mini.${domain}.com/center-api-adminqqs/upload/pic`,
    qqsProdUrl: `https://mini.${domain}.com/center-api-qqs/`,
    customerUrl: `https://mini.${domain}.com/customer-service`,
    adminToken:
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyTmFtZSI6IndhbmdteSIsImlhdCI6MTY3MDIxNDEyNX0.jMSXBjrX4pL3vL-4Ek3xHfmKxZ-D-Uziz9jkoyjiGco",
    customerLongLink: `https://mini.${domain}.com/`
  },
  stageQqs: {
    baceUrl: `https://stage.${domain}.com/center-api-adminqqs/`,
    // baceUrl: "https://stage.17zhuyu.com/center-api-adminqqs-8701",
    picUrl: `https://stage-cdn.${domain}.com/`,
    uploadUrl: `https://stage.${domain}.com/center-api-adminqqs/upload/pic`,
    customerUrl: `https://stage.${domain}.com/customer-service`,
    qqsProdUrl: `https://stage.${domain}.com/center-api-qqs`,
    adminToken:
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyTmFtZSI6IndhbmdteSIsImlhdCI6MTY1MTEzNjMxNn0.gNTKh6v-ME0qywX4o_xQ3VO8bneeaSNCxJUHwYgDEQo",
    customerLongLink: `https://stage.${domain}.com/`
  }
};
const state = {
  // env,
  envConfigs
};
export default state;



// WEBPACK FOOTER //
// ./src/store/state.js